import {axiosPostAuthorize,axiosGetAuthorize} from '../AxiosRequests';
import {GetInquiryProductsList,DeleteInquiryProducts,UpdateInquiryProductsStatus,GetInquiryProductsById,AddInquiryProducts
,GetProductIdForMapProduct,UpdateInquiryProductForMap,UpdateInquiryProductDetails} from '../ApiEndPoints';


export default class InquiryProductServices {

    //** Call API : */
    async addInquiryProducts(request) {
        return axiosPostAuthorize(AddInquiryProducts, request);
    }

    async UpdateInquiryProductDetails(request) {
        return axiosPostAuthorize(UpdateInquiryProductDetails, request);
    }

    async updateInquiryProductsStatus(request) {
        return axiosPostAuthorize(UpdateInquiryProductsStatus, request);
    }

    async deleteInquiryProducts(request) {
        return axiosPostAuthorize(DeleteInquiryProducts, request);
    }
    
    async getInquiryProductsById(request) {
        return axiosGetAuthorize(GetInquiryProductsById, request);
    }

    async getInquiryProductsList(request){
        return axiosPostAuthorize(GetInquiryProductsList, request);
    }     

    async getProductIdForMapProduct(request) {
        return axiosPostAuthorize(GetProductIdForMapProduct, request);
    }   

    async updateInquiryProductForMap(request) {
        return axiosPostAuthorize(UpdateInquiryProductForMap, request);
    }    
}